import { Inject, Injectable, Injector } from '@angular/core';

import { Document360_ReportService } from './Document360.report.index';
import { Usersnap_ReportService } from './Usersnap.report.index';
import { Utilities_ReportService } from './Utilities.report.index';
import { Addresses_ReportService } from './Addresses.report.index';
import { Discussions_ReportService } from './Discussions.report.index';
import { DockAppointments_ReportService } from './DockAppointments.report.index';
import { Owners_ReportService } from './Owners.report.index';
import { Instructions_ReportService } from './Instructions.report.index';
import { Materials_ReportService } from './Materials.report.index';
import { Carriers_ReportService } from './Carriers.report.index';
import { Locations_ReportService } from './Locations.report.index';
import { PurchaseOrders_ReportService } from './PurchaseOrders.report.index';
import { Invoices_ReportService } from './Invoices.report.index';
import { Notifications_ReportService } from './Notifications.report.index';
import { SalesOrders_ReportService } from './SalesOrders.report.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.Document360 = this.injector.get(Document360_ReportService);
    this.Usersnap = this.injector.get(Usersnap_ReportService);
    this.Utilities = this.injector.get(Utilities_ReportService);
    this.Addresses = this.injector.get(Addresses_ReportService);
    this.Discussions = this.injector.get(Discussions_ReportService);
    this.DockAppointments = this.injector.get(DockAppointments_ReportService);
    this.Owners = this.injector.get(Owners_ReportService);
    this.Instructions = this.injector.get(Instructions_ReportService);
    this.Materials = this.injector.get(Materials_ReportService);
    this.Carriers = this.injector.get(Carriers_ReportService);
    this.Locations = this.injector.get(Locations_ReportService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_ReportService);
    this.Invoices = this.injector.get(Invoices_ReportService);
    this.Notifications = this.injector.get(Notifications_ReportService);
    this.SalesOrders = this.injector.get(SalesOrders_ReportService);
    this.FootprintManager = this.injector.get(FootprintManager_ReportService);
  }
    public Document360: Document360_ReportService;
    public Usersnap: Usersnap_ReportService;
    public Utilities: Utilities_ReportService;
    public Addresses: Addresses_ReportService;
    public Discussions: Discussions_ReportService;
    public DockAppointments: DockAppointments_ReportService;
    public Owners: Owners_ReportService;
    public Instructions: Instructions_ReportService;
    public Materials: Materials_ReportService;
    public Carriers: Carriers_ReportService;
    public Locations: Locations_ReportService;
    public PurchaseOrders: PurchaseOrders_ReportService;
    public Invoices: Invoices_ReportService;
    public Notifications: Notifications_ReportService;
    public SalesOrders: SalesOrders_ReportService;
    public FootprintManager: FootprintManager_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

